import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=214f63df&scoped=true&"
import script from "./SwiperItem.vue?vue&type=script&lang=js&"
export * from "./SwiperItem.vue?vue&type=script&lang=js&"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=214f63df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f63df",
  null
  
)

export default component.exports